import { createGlobalStyle } from "styled-components";

const secondary = ({ theme }) => theme.secondarybody || theme.secondarycolor || theme.body;

export const GlobalStyles = createGlobalStyle`
body {
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text} !important;
  font-family: "Poppins", sans-serif !important;
}
header{
  background-color: ${({ theme }) => theme.body};
}
button {
  background-color:${({ theme }) => theme.button};
  color:${({ theme }) => theme.buttonText};
}
a,
a:hover{
  color: ${({ theme }) => theme.text};
}
input::placeholder,
textarea::placeholder {
  color: ${({ theme }) => theme.text} !important;
}
.theme-text-color {
  color: ${({ theme }) => theme.text} !important;
}
.theme-bg-color{
  background-color: ${({ theme }) => theme.body} !important;
}
.theme-bg-color-secondary{
  background-color: ${secondary} !important;
}
.theme-border-primary-color{
  border-color: ${({ theme }) => theme.body} !important;
}
.theme-border-secondary-color{
  border-bottom: 2px solid ${secondary} !important;
}
.theme-border-button-color{
  border-color: ${({ theme }) => theme.button} !important;
}
.theme-button-bg-color,
.button-bg-color,
.button-bg-color:hover {
  background-color: ${({ theme }) => theme.button} !important;
}
.theme-button-text-color{
  color: ${({ theme }) => theme.buttonText} !important;
}
.theme-border-secondary{
  border: 3px solid ${secondary} !important;
}
.theme-border-bottom-secondary{
  border-bottom: 2px solid ${secondary} !important;
}
.theme-border-color{
  border-color: ${secondary} !important;
}
.custom-input-border{
  border: 1px solid ${secondary} !important;
}
.custom-input{
  font-size: 13px;
  padding: 15px 20px;
  border-radius: 7px;
  font-weight: 500;
}
.admin-button-text {
  font-family: "Poppins", sans-serif !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 20px !important;
}
.admin-input-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
.admin-input-description {
  font-size: 13px;
  min-width: 80px;
}
.custom-input:focus-visible{
  outline: 1px solid ${secondary} !important;
}
.custom-input,
.custom-input:focus,
.custom-input:hover {
  background-color: transparent !important;
  color: ${({ theme }) => theme.text} !important;
}
.custom-input::placeholder {
  color: ${({ theme }) => theme.text} !important;
  opacity: 0.7;
}
.bootstrapTable table>thead>tr>th{
  border-bottom: 2px solid ${secondary} !important;
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text} !important;
}
.bootstrapTable table>tbody>tr{
  border-bottom: 2px solid ${secondary} !important;
}
.bootstrapTable table>tbody>tr>td{
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text} !important;
}
.bootstrapTable .page-link {
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text} !important;
  border-color:${secondary} !important;
}
.bootstrapTable .page-item.active > .page-link{
  background-color: ${secondary} !important;
}
.adminHeadContainer .dropdown-item:hover,
.adminHeadContainer .dropdown-item:focus,
.editdropdown-menu a:hover,
.commonActionPadding:hover,
.secondary:hover {
  background-color: ${secondary} !important;
}
.primary:hover{
  background-color:${({ theme }) => theme.body} !important;
}
#pageDropDown{
  background-color: ${({ theme }) => theme.body};
  border: 1px solid ${secondary} !important;
  color: ${({ theme }) => theme.text} !important;
}
.css-1nmdiq5-menu > *{
  background-color: ${secondary} !important;
  color: ${({ theme }) => theme.text} !important;
}
.admin-select__control {
  background-color: transparent !important;
  border-color: ${secondary} !important;
  border-radius: 7px !important;
  min-height: 51px !important;
  box-shadow: none !important;
}
.admin-select__value-container {
  padding: 4px 14px !important;
}
.admin-select__single-value,
.admin-select__input-container,
.admin-select__placeholder {
  color: ${({ theme }) => theme.text} !important;
}
.admin-select__indicator svg {
  fill: ${({ theme }) => theme.text} !important;
}
.admin-select__menu {
  background-color: ${({ theme }) => theme.body} !important;
  border: 1px solid ${secondary} !important;
  overflow: hidden;
}
.admin-select__option {
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text} !important;
}
.admin-select__option--is-focused,
.admin-select__option--is-selected {
  background-color: ${secondary} !important;
  color: ${({ theme }) => theme.text} !important;
}
.css-1p3m7a8-multiValue,
.css-wsp0cs-MultiValueGeneric{
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text};
}
.css-1xc3v61-indicatorContainer >svg{
  fill:${({ theme }) => theme.text};
}
.rti--tag{
  background-color: ${({ theme }) => theme.body};
}
input:checked+.admin-slider,
.vjs-big-play-button{
  background-color:${({ theme }) => theme.button} !important;
}
input:focus+.admin-slider {
  box-shadow: 0 0 1px ${({ theme }) => theme.button};
}
.admin-slider:before {
  background-color:${({ theme }) => theme.buttonText};
}
`;
